import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { DataPlanDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchDataPlans } from "../../../../features/auth/store/dataPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import DataPlans from "./DataPlan";

const DataPlanRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedDataPlan, setSelectedDataPlan] = useState<Product | null>(
    null
  );
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { dataPlans, loading, error } = useSelector(
    (state: RootState) => state.dataPlans
  );

  useEffect(() => {
    const filters: any = {};

    // Only add status filter if it's not empty
    if (statusFilter && statusFilter !== "") {
      filters.status = statusFilter;
    }
    if (searchTerm && searchTerm !== "") {
      filters.search = searchTerm;
    }

    dispatch(fetchDataPlans(filters));
  }, [dispatch, statusFilter, searchTerm]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleDataPlanClick = (dataPlan: Product) => {
    setSelectedDataPlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedDataPlan(null);
  };

  if (showDetailView && selectedDataPlan) {
    return (
      // <ProductDetailView dataPlan={selectedDataPlan} onBack={handleBackToList} />
      <DataPlanDetailView
        dataPlan={{
          ...selectedDataPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <DataPlans
      dataPlans={dataPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onDataPlanClick={handleDataPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default DataPlanRouter;
